export interface DocTypeMetadatas {
    documentationTypeId: number;
    metadataId: number;
    systemName: string;
    categoryId: number;
    id: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    optionValues?: any;
}

export enum DocTypeMetadatasCategory {
    Subtipo = 1
  }
